import React from "react"
import { graphql } from "gatsby"
import { ThematicFoldersFieldsFragment, DatoCmsThematicFolder } from "../../../../graphql-types"
import ThematicCard from "../../../components/common/jsx/thematic-card/thematic-card"
import * as styles from "./thematic-folders.module.scss"
type ThematicFoldersProps = {
  thematicFolders: DatoCmsThematicFolder[]
  data: ThematicFoldersFieldsFragment
  thematicFoldersPageSlug: string
  projectsNewsInsightsPageSlug: string
}
const ThematicFolders: React.FC<ThematicFoldersProps> = ({ thematicFolders, data, thematicFoldersPageSlug, projectsNewsInsightsPageSlug }) => {
  return (
    <section className={styles.container}>
      {thematicFolders.map((thematicFolder) => (
        <ThematicCard key={thematicFolder.id} data={thematicFolder} thematicFolderSlug={thematicFoldersPageSlug} projectsNewsInsightsPageSlug={projectsNewsInsightsPageSlug} />
      ))}
    </section>
  )
}

export const fragment = graphql`
  fragment ThematicFoldersFields on DatoCmsThematicFoldersPage {
    thematicFolders {
      ...ThematicCardFields
    }
  }
`

export default ThematicFolders

